// import React from 'react';
// import { Text, View, StyleSheet } from '@react-pdf/renderer';
// // import {
// //     blueGrey
// //   } from '@mui/material/colors'
// //   import {
// //     createTheme
// //   } from '@mui/material/styles';

// // const theme = createTheme({
// //     palette: {
// //         primary: {
// //             main: blueGrey[900],
// //         },
// //         secondary: {
// //             main: blueGrey[300],
// //         },
// //     },
// //   });

// const borderColor = 'black'
// const styles = StyleSheet.create({
//     container: {
//         flexDirection: 'row',
//         borderBottomColor: 'black',
//          backgroundColor: "#e6e6e6",
//         color: 'black',
//         borderBottomWidth: 1,
//         borderLeftWidth: 1,
//         borderRightWidth: 1,
//         borderTopWidth: 1,
//         alignItems: 'center',
//         height: 22,
//         textAlign: 'center',
//         // fontStyle: 'bold',
//         fontWeight: "extrabold",
//         flexGrow: 1,
//     },
//     description: {
//         width: '40%',
//         borderRightColor: borderColor,
//         borderRightWidth: 1,
//         textAlign: 'center',
//         fontSize: 8.5
//     },
//     qty: {
//         width: '10%',
//         borderRightColor: borderColor,
//         borderRightWidth: 1,
//         textAlign: 'center',
//         fontSize: 8.5
//     },
//     UM: {
//         width: '7%',
//         borderRightColor: borderColor,
//         borderRightWidth: 1,
//         textAlign: 'center',
//         fontSize: 8.5
//     },
//     rate: {
//         width: '20%',
//         borderRightColor: borderColor,
//         borderRightWidth: 1,
//         textAlign: 'center',
//         fontSize: 8.5
//     },
//     Sno: {
//         width: '5%',
//         borderRightColor: borderColor,
//         borderRightWidth: 1,
//         fontSize: 8.5,
//         textAlign: 'center',
//         borderLeftWidth: 1,
//     },
//     amount: {
//         width: '15%',
//         textAlign: 'center',
//         fontSize: 8.5
//     },
//     SKU: {
//         width: '15%',
//         borderRightColor: borderColor,
//         borderRightWidth: 1,
//         textAlign: 'center',
//         paddingRight: 8,
//         fontSize: 8.5
//     },
// });

// const InvoiceTableHeader = ({invoice}) => (
//     <View style={styles.container}>
//         <Text style={styles.Sno}>Clin Id</Text>
//         <Text style={styles.SKU}>Product Number</Text>
//         <Text style={styles.description}>Item Description</Text>
//         <Text style={styles.qty}>Qty</Text>
//         {/* <Text style={styles.UM}>UM</Text> */}
//         <Text style={styles.rate}>Unit Price</Text>
//         <Text style={styles.amount}>Total</Text>
//     </View>
// );

// export default InvoiceTableHeader;

import React from "react";
import { Text, View, StyleSheet } from "@react-pdf/renderer";

const borderColor = "black";

const styles = StyleSheet.create({
  container: {
    flexDirection: "row",
    borderBottomColor: "black",
    backgroundColor: "#e6e6e6",
    color: "black",
    borderBottomWidth: 1,
    borderLeftWidth: 1,
    borderRightWidth: 1,
    borderTopWidth: 1,
    alignItems: "center",
    height: 22,
    textAlign: "center",
    fontWeight: "extrabold",
    flexGrow: 1,
  },
  description: {
    textAlign: "center",
    borderRightColor: borderColor,
    borderRightWidth: 1,
    fontSize: 8.5,
  },
  qty: {
    borderRightColor: borderColor,
    borderRightWidth: 1,
    textAlign: "center",
    fontSize: 8.5,
  },
  rate: {
    borderRightColor: borderColor,
    borderRightWidth: 1,
    textAlign: "center",
    fontSize: 8.5,
  },
  SKU: {
    borderRightColor: borderColor,
    borderRightWidth: 1,
    borderLeftWidth: 1,
    textAlign: "center",
    paddingRight: 8,
    fontSize: 8.5,
  },
  amount: {
    textAlign: "center",
    fontSize: 8.5,
  },
  Sno: {
    borderRightColor: borderColor,
    // borderRightWidth: 1,
    fontSize: 8.5,
    textAlign: "center",
    // borderLeftWidth: 1,
  },
});

const InvoiceTableHeader = ({ invoice }) => {
  // Determine if we should show the Sno (Clin Id) column
  const showSNo = invoice?.products?.some((item) => item.clin_id);

  // Adjust column widths based on whether we show Sno or not
  const descriptionWidth = showSNo ? "35%" : "34%";
  const SKUWidth = showSNo ? "17%" : "21%";
  const qtyWidth = showSNo ? "10%" : "11%";
  const rateWidth = showSNo ? "18%" : "19%";
  const amountWidth = showSNo ? "15%" : "15%";
  const SNoWidth = showSNo ? "5%" : "0%";

  return (
    <View style={styles.container}>
      {showSNo && (
        <Text style={{ ...styles.Sno, width: SNoWidth }}>CLIN</Text>
      )}
      <Text style={{ ...styles.SKU, width: SKUWidth }}>Product Number</Text>
      <Text style={{ ...styles.description, width: descriptionWidth }}>
        Item Description
      </Text>
      <Text style={{ ...styles.qty, width: qtyWidth }}>Qty</Text>
      {/* <Text style={styles.UM}>UM</Text> */}
      <Text style={{ ...styles.rate, width: rateWidth }}>Unit Price</Text>
      <Text style={{ ...styles.amount, width: amountWidth }}>Total</Text>
    </View>
  );
};

export default InvoiceTableHeader;
